import { Can } from 'components/Can';
import LiquidationReviewCRUForm from 'features/LiquidationReview/pages/CRU';
import Layout from 'layout';
import { Action, Subject } from 'constant/casl.constant';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function LiquidationReviewCreateEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do={Action.READ} on={Subject.LIQUIDATION_REVIEW}>
          <LiquidationReviewCRUForm readOnly={false} />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
